import { Typography } from '@components/Typography';
import { formatNumber, formatOptionalNumber as formatOptional } from '@helpers/formatNumbers';
import { TableCellText } from '../../Feedback/FeedbackTable';

// Renders top-level rows: one per campaign (campaignTotal=true). Per-profile child rows
// are rendered by CollapsibleRowBody when the parent is expanded.
export const getTableBody = data => {
    return data.map(({ campaignTitle, campaignTotal = false, reach, likes, comments, shares, clicks, saves }) => {
        return campaignTotal
            ? [
                  {
                      component: (
                          <Typography variant="subtitle2" align="left">
                              {campaignTitle || 'NA'}
                          </Typography>
                      ),
                  },
                  {
                      component: (
                          <TableCellText variant="body2" align="right">
                              {formatNumber(reach)}
                          </TableCellText>
                      ),
                  },
                  {
                      component: (
                          <TableCellText variant="body2" align="right">
                              {formatNumber(likes)}
                          </TableCellText>
                      ),
                  },
                  {
                      component: (
                          <TableCellText variant="body2" align="right">
                              {formatNumber(comments)}
                          </TableCellText>
                      ),
                  },
                  {
                      component: (
                          <TableCellText variant="body2" align="right">
                              {formatNumber(shares)}
                          </TableCellText>
                      ),
                  },
                  {
                      component: (
                          <TableCellText variant="body2" align="right">
                              {formatOptional(clicks)}
                          </TableCellText>
                      ),
                  },
                  {
                      component: (
                          <TableCellText variant="body2" align="right">
                              {formatOptional(saves)}
                          </TableCellText>
                      ),
                  },
              ]
            : null;
    });
};
